












































import { Vue, Component } from "vue-property-decorator";
import { Getter,Action } from "vuex-class";
@Component
export default class GachaPrizeCard extends Vue {
  @Getter("gachaTypeParameter") gachaTypeParameter!: object;
  @Getter("section") section!: object;
  @Action("changeSelectedCardIndex") changeSelectedCardIndex!: Function;
  showModal(theIndex:any){
    this.changeSelectedCardIndex(theIndex);
    this.$emit('showCardModal');
  }
}
